<template>
  <div class="vtk-container-wrapper" tabindex="0">
    <div class="vtk-gutter" :style="{background:'#ffffff'}"></div>
    <div class="vtk-container" data-testid="two-view-container">
      <div class="vtk-sub-container">

        <vtk-volume-view
          class="vtk-view"
          ref="vtkView"
          data-testid="vtk-view"
          :view-id="id"
          :image-id="currentImageID"
          :view-direction="viewDirection"
          :view-up="viewUp"
        >
          <template v-for="(sliceProps, idx) in obliqueSliceProps" :key="idx">
            <vtk-base-oblique-slice-representation
              :view-id="sliceProps.viewId"
              :image-id="currentImageID"
              :plane-normal="sliceProps.planeNormal"
              :plane-origin="sliceProps.planeOrigin"
            ></vtk-base-oblique-slice-representation>
            <vtk-image-outline-representation
              v-if="!currentImageMetadata.isDynamic"
              :view-id="sliceProps.viewId"
              :image-id="currentImageID"
              :plane-normal="sliceProps.planeNormal"
              :plane-origin="sliceProps.planeOrigin"
              :thickness="4"
              :color="sliceProps.outlineColor"
            ></vtk-image-outline-representation>
<!--             <vtk-image-outline-representation
              v-if="viewStore.layout.name != 'Digyne 3D Only'"
              :view-id="sliceProps.viewId"
              :image-id="currentImageID"
              :plane-normal="sliceProps.planeNormal"
              :plane-origin="sliceProps.planeOrigin"
              :thickness="4"
              :color="sliceProps.outlineColor"
            ></vtk-image-outline-representation>
-->
            <vtk-slice-updater
              v-if="currentImageMetadata.isDynamic"
              :view-id="id"
              :image-id="currentImageID"
              :view-direction="viewDirection"
              :view-up="viewUp">
            </vtk-slice-updater>

          </template>

          <template v-for="(model, idx) in modelProps" :key="idx">
            <vtk-base-model-representation
              :model-id="model.id"
              :model-display="model.display"
              :color="model.color"
            ></vtk-base-model-representation>
          </template>
          <slot></slot>
          <!-- <v-btn @click="() => { console.log('Inline test click'); }">
          Click Me Up
          </v-btn> -->
<!--           <div v-if="currentImageMetadata.isDynamic">
          <v-btn @click="() => { console.log('Inline test click'); }">Click Me Dyn
          </v-btn>
            <dyn-viewer-overlay
              :view-id="id"
              :image-id="currentImageID"
            ></dyn-viewer-overlay>
          </div> -->
<!--           <vtk-slice-updater
            :view-id="id"
            :image-id="currentImageID"
            :view-direction="viewDirection"
            :view-up="viewUp">
          </vtk-slice-updater>
 -->
        </vtk-volume-view>


        <div v-if="currentImageMetadata.isDynamic" class="concontainer">
          <dyn-viewer-overlay
            :view-id="obliqueSliceProps[0].viewId"
            :image-id="currentImageID"
          ></dyn-viewer-overlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, unref, toRefs, computed, watch, watchEffect } from 'vue';
import { watchImmediate } from '@vueuse/core';
import { useCurrentImage } from '@/src/composables/useCurrentImage';
import { LPSAxis, LPSAxisDir } from '@/src/types/lps';
import VtkVolumeView from '@/src/components/vtk/VtkVolumeView.vue';
// import VtkSliceUpdater from '@/src/components/vtk/VtkSliceUpdater.vue';
import { VtkViewApi } from '@/src/types/vtk-types';
import { LayoutViewProps } from '@/src/types';
import DynViewerOverlay from '@/src/components/DynViewerOverlay.vue';
import VtkBaseObliqueSliceRepresentation from '@/src/components/vtk/VtkBaseObliqueSliceRepresentation.vue';
import VtkImageOutlineRepresentation from '@/src/components/vtk/VtkImageOutlineRepresentation.vue';
import { useViewAnimationListener } from '@/src/composables/useViewAnimationListener';
import { useWebGLWatchdog } from '@/src/composables/useWebGLWatchdog';
import useResliceCursorStore, {
  mapAxisToViewType,
} from '@/src/store/reslice-cursor';
import { vtkFieldRef } from '@/src/core/vtk/vtkFieldRef';
import { useResetViewsEvents } from '@/src/components/tools/ResetViews.vue';
import { vec3 } from 'gl-matrix';
import { OBLIQUE_OUTLINE_COLORS, MODEL_ORGAN_COLORS } from '@/src/constants';
import type { RGBColor, Vector3 } from '@kitware/vtk.js/types';

import { whenever } from '@vueuse/core';
import { useSliceConfig } from '@/src/composables/useSliceConfig';

import VtkBaseModelRepresentation from '@/src/components/vtk/VtkBaseModelRepresentation.vue';

import useViewSliceStore from '@/src/store/view-configs/slicing';
import { useViewStore } from '@/src/store/views';
import { getLPSAxisFromDir } from '@/src/utils/lps';

import {  useModelStore } from '@/src/store/datasets-models';

import { InitViewIDs, InitViewSpecs } from '../config';
import { resetCameraToImage } from '@/src/utils/camera';
import { storeToRefs } from 'pinia';


interface SliceSpec {
  viewID: string;
  axis: LPSAxis;
}

interface ModelSpec {
  modelID: string;
  name: string;
}


interface Props extends LayoutViewProps {
  viewDirection: LPSAxisDir;
  viewUp: LPSAxisDir;
  slices: SliceSpec[];
  // models: ModelSpec[];
}

const vtkView = ref<VtkViewApi>();

const props = defineProps<Props>();

const viewSliceStore = useViewSliceStore();
const viewStore = useViewStore();

// watch(viewStore.layout,
//   () => {
//      console.log("layoutName.value",viewStore.layout.name);
//   });

const {
  id: viewId,
  type: viewType,
  viewDirection,
  viewUp,
  slices,
  // models,
} = toRefs(props);

useViewAnimationListener(vtkView, viewId, viewType);


// base image
const { currentImageID, currentImageMetadata, isImageLoading } = useCurrentImage();

whenever(
  computed(() => !isImageLoading.value),
  () => {
    resetCamera();
  }
);


// watch(currentImageID, ()=> {
//   console.log("DNAS MOSlice&SimuViewer, currentImageID update detected")
//   if(unref(currentImageMetadata).isDynamic)
//   {
//     const { slice: currentSlice, range: sliceRange } = useSliceConfig(
//       viewId,
//       currentImageID
//     );
//   }
// });

// const { slice: currentSlice, range: sliceRange } = useSliceConfig(
//   viewId,
//   currentImageID
// );


// reslice cursor
const resliceStore = useResliceCursorStore();
const { resliceCursor, resliceCursorState } = resliceStore;

// -----

// const { slice: thisViewSlice } = useSliceConfig(unref(viewId),currentImageID);

const resliceCenter = vtkFieldRef(resliceCursorState, 'center');
const obliqueSliceProps = computed(() => {
  return slices.value
    .filter(sliceSpec => {
      const thisSliceConfig = viewSliceStore.getConfig(sliceSpec.viewID, currentImageID.value);
      if(thisSliceConfig != null)
      {
        const thisAxis = currentImageMetadata.value.lpsOrientation[getLPSAxisFromDir(thisSliceConfig.axisDirection)];
        return !unref(currentImageMetadata).isDynamic || unref(currentImageMetadata).isDynamic && thisAxis == unref(currentImageMetadata).mainAxis;
      }
      else
        return false;
    })
    .map((sliceSpec) => {
      viewDirection.value = InitViewSpecs[sliceSpec.viewID].props.viewDirection;

      const planeNormal = resliceCursor.getPlaneNormalFromViewType(
        mapAxisToViewType(sliceSpec.axis)
      );

      const outlineColor = vec3.scale(
        [0, 0, 0],
        OBLIQUE_OUTLINE_COLORS[sliceSpec.viewID],
        1 / 255
      ) as RGBColor;

      return {
        viewId: sliceSpec.viewID,
        planeNormal,
        planeOrigin: resliceCenter.value,
        outlineColor,
    };
  });
});

const { idList, metadata } = useModelStore();
const modelProps = computed(() => {
  return idList.map((modelId) => {
    return {
      id: modelId,
      name: metadata[modelId].name,
      display: true,
      color: metadata[modelId].color,
    };
  });
});

const { renderTrigger } = storeToRefs(useModelStore());
watch(renderTrigger, () => {
  if (!vtkView.value) return;
  // console.log("coucou on requestRender 2/2", renderTrigger.value)
  vtkView.value.requestRender();
})

// reset camera logic
function resetCamera() {
  if (!vtkView.value) return;
  vtkView.value.resetCamera();
  vtkView.value.requestRender();
}

useResetViewsEvents().onClick(resetCamera);
</script>

<style scoped src="@/src/components/styles/vtk-view.css"></style>
<style scoped src="@/src/components/styles/utils.css"></style>
